var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"VotingResult"},[_c('div',{staticClass:"alert alert-success"},[_vm._v(" Su voto fue procesado exitosamente, Gracias. ")])])}]

export { render, staticRenderFns }